import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListEvidences } from "../../../components/Admin/Evidences";
import "./Evidences.scss";
import { useLanguage } from "../../../contexts";

export function Evidences() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    { menuItem: t("active_evidences"), render: () => (<Tab.Pane attached={false}><ListEvidences evidencesActive={true} reload={reload} onReload={onReload} /></Tab.Pane>) },
    { menuItem: t("inactive_evidences"), render: () => (<Tab.Pane attached={false}><ListEvidences evidencesActive={false} reload={reload} onReload={onReload} /></Tab.Pane>) },
  ];

  return (
    <div className="evidences-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="evidences-page-header-wrapper">
        <div className="evidences-page-header">
          <span className="evidences-page-title">{t("evidences")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
